import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import PopUp from 'shared/components/pop-up/pop-up';

import Device from 'features/device/domain/models/device';
import { useDeviceDeleteHook } from 'features/device/hooks/device-delete-hook';

type Props = {
  device: Device | undefined;
  handleOnClose: () => void;
};

const DeviceDeletePopup = ({ device, handleOnClose }: Props): ReactElement => {
  const { t } = useTranslation('devices');

  const {
    isDeleteConfirmationPopupOpen,
    isDeleteErrorPopupOpen,
    closeDeleteConfirmationPopup,
    closeDeleteErrorPopup,
    deleteDevice,
    deleteDeviceIsLoading,
    deleteErrorMessageId,
  } = useDeviceDeleteHook(device, handleOnClose);

  return (
    <>
      <PopUp
        isOpen={isDeleteConfirmationPopupOpen}
        title={t('deleteDeviceConfirmation.title', {
          deviceName: device?.name,
        })}
        body={t('deleteDeviceConfirmation.bodyText')}
        primaryButtonText={t('deleteDeviceConfirmation.confirmButton')}
        secondaryButtonText={t('deleteDeviceConfirmation.cancelButton')}
        handleOnClose={() => {
          closeDeleteConfirmationPopup();
          handleOnClose();
        }}
        secondaryButtonAction={() => {
          closeDeleteConfirmationPopup();
          handleOnClose();
        }}
        primaryButtonAction={() => {
          deleteDevice();
        }}
        isLoadingPrimaryAction={deleteDeviceIsLoading}
      />

      <PopUp
        isOpen={isDeleteErrorPopupOpen}
        title={t('deleteDeviceError.title', {
          deviceName: device?.name,
        })}
        body={t(`deleteDeviceError.${deleteErrorMessageId}`)}
        primaryButtonText={t('deleteDeviceError.confirmButton')}
        handleOnClose={() => {
          closeDeleteErrorPopup();
          handleOnClose();
        }}
        primaryButtonAction={() => {
          closeDeleteErrorPopup();
          handleOnClose();
        }}
      />
    </>
  );
};

export default DeviceDeletePopup;
